<template>
    <div
        class="sticky top-0 z-10 px-3 py-2 text-xs font-semibold text-muted-foreground/90 uppercase tracking-wider bg-muted/20 border-b border-border/30 backdrop-blur-sm"
        role="group"
        :aria-label="`${title} tab group`"
        :id="`group-${slugify(title)}`">
        {{ title }}
    </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        required: true
    }
});

// Create a URL-friendly slug for the group ID
const slugify = (text) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};
</script>
